import './css/main.css'
import { Link, useNavigate } from "react-router-dom"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass, faCircleXmark, faSortDown, faSortUp, faWindowMinimize, faPenToSquare, faLock, faLockOpen } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useRef, useState } from 'react';
import NewPage from './common/NewPage'
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { changeLogId, checkLogin } from '../store';
import { SyncLoader } from "react-spinners";
import Message from './common/message';
import { ListRestart } from 'lucide-react';
import moment from 'moment';

import { changeNum } from './common/function';

import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";

function Member() {
    const [search, setSearch] = useState("")
    const [select, setSelect] = useState(false)
    const [selectValue, setSelectValue] = useState("ID & 이름")
    const [page, setPage] = useState(1)
    const [reload, setReload] = useState(false)
    const [spinner, setSpinner] = useState(false)
    const [message, setMessage] = useState({ code: -1, msg: "" })
    const [totalData, setTotalData] = useState(0)
    const [securetNum, setSecuretNum] = useState(0)

    const [skinModal, setSkinModal] = useState(false)
    const [diaModal, setDiaModal] = useState(false)
    const [upgradeModal, setUpgradeModal] = useState(false)
    const [walletAddressModal, setWalletAddressModal] = useState(false)
    const [securetCodeModal, setSecuretCodeModal] = useState(false)

    const [clickId, setClickId] = useState([])
    const [data, setData] = useState([])
    const [dataList, setDataList] = useState([])
    const [upgradeLevel, setUpgradeLevel] = useState([1, 1])

    // 정렬 상태(0: 정렬 안함, 1: 내림차순, 2: 오름차순)
    const [name1, setName1] = useState(0); // 획득 다이아
    const [name2, setName2] = useState(1); // 최근 접속
    const [name3, setName3] = useState(0); // 시큐릿코드

    let dark = useSelector((state) => { return state.Darkmode.value });

    const darkname = dark ? 'dark' : "";
    let dispatch = useDispatch();
    const navigate = useNavigate();

    // 로그인 토큰 체크
    useEffect(() => {
        const objString = localStorage.getItem('token');
        if (objString != null) {
            const obj = JSON.parse(objString);
            if (Date.now() > obj.expire) {
                localStorage.removeItem('token');
                dispatch(checkLogin(false));
                navigate('/')
            }
            else {
                dispatch(checkLogin(true));
            }
        }
        else {
            dispatch(checkLogin(false));
            navigate('/')
        }
    }, [dispatch, navigate])

    const onChangeSearch = (e) => {
        setSearch(e.target.value)
    }

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            setPage(1)
            setReload(e => !e)
        }
    };

    useEffect(() => {
        UpgradeData()
    }, [reload, name1, name2, page])

    useEffect(() => {
        UpgradeLevelData()
        CoinRateData()
    }, [])

    const UpgradeData = async () => {
        setSpinner(true)
        await axios.get(process.env.REACT_APP_API + '/api/user', {
            params: {
                page: page,
                limit: 20,
                search: search,
                sortBy: name1 === 0 ? "access_date" : name2 === 0 ? "user_gold" : "", //user_gold(포인트), access_date(접속일시)
                sortOrder: name1 === 1 ? "DESC" : name1 === 2 ? "ASC" : name2 === 1 ? "DESC" : name2 === 2 ? "ASC" : "", //ASC(오름차순), DESC(내림차순)
            }
            // headers: { Authorization: `Bearer ${JWT}` }
        }).then((response) => {
            let tmp = response.data
            console.log(tmp)
            if (tmp?.code == 1000) {
                setData(tmp?.data?.user ?? [])
                setTotalData(tmp?.data?.pagination?.totalUsers ?? 0)
                setSecuretNum(0)
                setSpinner(false)
            }
            else setSpinner(false)
        }).catch((error) => {
            console.log(error)
        })
    };

    const UpgradeLevelData = async () => {
        await axios.get(process.env.REACT_APP_API + '/api/up', {
            // headers: { Authorization: `Bearer ${JWT}` }
        }).then((response) => {
            let tmp = response.data
            if (tmp?.code === 1000) {
                let Data = tmp?.data?.upgrade['energy-limit'] ?? []
                setUpgradeLevel([
                    Data.filter((item) => item.up_type === 'tab-plus').length,
                    Data.filter((item) => item.up_type === 'energy-limit').length
                ])
            }
        }).catch((error) => {
            console.log(error)
        })
    };

    // 코인 전환(시즌종료) 버튼 이벤트
    const onSubmitEndSeason = async () => {
        if (window.confirm("시즌종료 하시겠습니까? 시즌이 종료되면 현재를 기준으로 전환 가능 코인 개수가 정해집니다.")) {
            await axios.post(process.env.REACT_APP_API + '/api/season/change', {
            }).then((response) => {
                let tmp = response.data
                if (tmp?.code === 1000) {
                    setReload(e => !e)
                }
            }).catch((error) => {
                console.log(error)
            })
        }
    };

    const [rateData, setRateData] = useState([])

    const CoinRateData = async () => {
        setSpinner(true)
        await axios.get(process.env.REACT_APP_API + '/api/setting', {
            // headers: { Authorization: `Bearer ${JWT}` }
        }).then((response) => {
            let tmp = response.data
            if (tmp?.code === 1000) {
                const setting999 = tmp?.data?.setting?.find(item => item.id === 999)?.value?.split(':');
                setRateData({
                    "coin": setting999[1],
                    "point": setting999[0]
                });
            }
        }).catch((error) => {
            console.log(error)
            setSpinner(false)
        })
    };


    return (
        <div className='main'>
            <Message message={message} />
            {skinModal && (<MemberModal darkname={darkname} setSkinModal={setSkinModal} clickId={clickId} setReload={setReload} />)}
            {diaModal && (<DiaModal darkname={darkname} setDiaModal={setDiaModal} clickId={clickId} setReload={setReload} />)}
            {upgradeModal && (<UpgradeModal darkname={darkname} setUpgradeModal={setUpgradeModal} clickId={clickId} setReload={setReload} upgradeLevel={upgradeLevel} />)}
            {walletAddressModal && (<WalletAddressModal darkname={darkname} setWalletAddressModal={setWalletAddressModal} clickId={clickId} setReload={setReload} />)}
            {securetCodeModal && (<SecuretCodeModal darkname={darkname} setSecuretCodeModal={setSecuretCodeModal} clickId={clickId} setReload={setReload} />)}

            <div className={`main-box ${darkname}`}>
                <div className='member-1'>
                    <div className={`member-2-search ${darkname}`}>
                        <div className={`member-1-select ${darkname}`} onClick={() => setSelect(e => !e)}>
                            <div className={`member-1-select-1 ${darkname}`}>{selectValue}</div>
                            {
                                select
                                    ? <FontAwesomeIcon icon={faSortUp} />
                                    : <FontAwesomeIcon icon={faSortDown} />
                            }
                            {
                                select
                                    ? <>
                                        <div className='modal' onClick={() => setSelect(true)}></div>
                                        <div className={`member-1-select-box ${darkname}`}>
                                            <div onClick={() => { setSelectValue(`ID & 이름`); setSelect(false) }}>ID & 이름</div>
                                        </div>
                                    </>
                                    : null
                            }
                        </div>
                        <FontAwesomeIcon icon={faWindowMinimize} className='line' />
                        <div className={`member-2-search-1 ${darkname}`}>
                            <input
                                value={search}
                                onChange={onChangeSearch}
                                placeholder='Search'
                                onKeyDown={handleKeyPress}
                            />
                            <FontAwesomeIcon icon={faMagnifyingGlass} className='member-1-search-ico-3' />
                            {
                                search.length > 0 &&
                                <FontAwesomeIcon
                                    icon={faCircleXmark}
                                    className='member-1-search-ico-2'
                                    onClick={() => setSearch("")}
                                />
                            }
                        </div>
                    </div>
                    <div className={`search-btn ${darkname}`} onClick={() => { setReload(e => !e); setPage(1) }}>Search</div>
                    <div
                        className={`maintab-1-2 ${darkname}`}
                        style={{ position: "relative", marginLeft: "20px" }}
                        onClick={() => { onSubmitEndSeason() }}
                    >
                        코인일괄전환
                    </div>
                    <div style={{ fontWeight: "700", opacity: ".6", fontSize: "14px", paddingLeft: "10px" }}>
                        다이아 : 코인 = {rateData.point} : {rateData.coin}
                    </div>
                </div>

                <div className={`member-2 ${darkname}`}>
                    <div className={`table-head ${darkname}`}>
                        <div style={{ width: "5%", minWidth: "100px" }}>유저 아이디</div>
                        <div style={{ width: "15%", minWidth: "120px" }}>이름</div>
                        <div style={{ width: "10%", minWidth: "130px" }}>시큐릿 코드({securetNum})</div>
                        {/* <div
                            className={name3 === 0 ? 'table-sort' : 'table-sort sort-color'}
                            onClick={() => {
                                setName3(name3 => name3 === 1 ? 2 : 1);
                                setName2(0);
                                setName1(0);
                            }}
                            style={{ width: "10%", minWidth: "130px" }}
                        >
                            <span>시큐릿 코드({filterData.filter(item => item?.securet_code != null)?.length ?? "0"})</span>
                            <span style={{ paddingTop: "1px" }}>
                                <span className="index_sort-btn__eWsx8">
                                    <svg width="9" height="6" viewBox="0 0 5 3" fill="none">
                                        <path
                                            className={`${name3 === 2 ? "fill-color" : ""}`}
                                            d="M0.342163 3L3.77567 3C3.96395 3 4.11658 2.85941 4.11658 2.68599C4.11658 2.62399 4.09665 2.56339 4.05932 2.5118L2.34257 0.139848C2.23813 -0.00444984 2.02647 -0.0434422 1.86981 0.0527565C1.83236 0.0757532 1.80023 0.105353 1.77526 0.139848L0.0585074 2.5118C-0.0459313 2.6561 -0.00359917 2.85106 0.153059 2.94726C0.20906 2.98165 0.274858 3 0.342163 3Z"
                                            fill={"#999"}
                                        />
                                    </svg>
                                    <svg width="9" height="6" viewBox="0 0 5 3" fill="none">
                                        <path
                                            className={`${name3 === 1 ? "fill-color" : ""}`}
                                            d="M3.77442 0H0.340911C0.152631 0 0 0.140589 0 0.314014C0 0.376008 0.0199222 0.436615 0.0572559 0.488197L1.77401 2.86015C1.87845 3.00445 2.09011 3.04344 2.24677 2.94724C2.28422 2.92425 2.31635 2.89465 2.34132 2.86015L4.05807 0.488197C4.16251 0.343899 4.12018 0.148937 3.96352 0.0527385C3.90752 0.0183503 3.84172 0 3.77442 0Z"
                                            fill={"#999"}
                                        />
                                    </svg>
                                </span>
                            </span>
                        </div> */}

                        <div
                            className={name2 === 0 ? 'table-sort' : 'table-sort sort-color'}
                            onClick={() => {
                                setName2(name2 => name2 === 1 ? 2 : 1);
                                setName1(0);
                                setPage(1)
                            }}
                            style={{ width: "10%", minWidth: "100px" }}
                        >
                            <span>최근 접속</span>
                            <span style={{ paddingTop: "1px" }}>
                                <span className="index_sort-btn__eWsx8">
                                    <svg width="9" height="6" viewBox="0 0 5 3" fill="none">
                                        <path
                                            className={`${name2 === 2 ? "fill-color" : ""}`}
                                            d="M0.342163 3L3.77567 3C3.96395 3 4.11658 2.85941 4.11658 2.68599C4.11658 2.62399 4.09665 2.56339 4.05932 2.5118L2.34257 0.139848C2.23813 -0.00444984 2.02647 -0.0434422 1.86981 0.0527565C1.83236 0.0757532 1.80023 0.105353 1.77526 0.139848L0.0585074 2.5118C-0.0459313 2.6561 -0.00359917 2.85106 0.153059 2.94726C0.20906 2.98165 0.274858 3 0.342163 3Z"
                                            fill={"#999"}
                                        />
                                    </svg>
                                    <svg width="9" height="6" viewBox="0 0 5 3" fill="none">
                                        <path
                                            className={`${name2 === 1 ? "fill-color" : ""}`}
                                            d="M3.77442 0H0.340911C0.152631 0 0 0.140589 0 0.314014C0 0.376008 0.0199222 0.436615 0.0572559 0.488197L1.77401 2.86015C1.87845 3.00445 2.09011 3.04344 2.24677 2.94724C2.28422 2.92425 2.31635 2.89465 2.34132 2.86015L4.05807 0.488197C4.16251 0.343899 4.12018 0.148937 3.96352 0.0527385C3.90752 0.0183503 3.84172 0 3.77442 0Z"
                                            fill={"#999"}
                                        />
                                    </svg>
                                </span>
                            </span>
                        </div>

                        {/* 획득 다이아 정렬 */}
                        <div
                            className={name1 === 0 ? 'table-sort' : 'table-sort sort-color'}
                            onClick={() => {
                                setName1(name1 => name1 === 1 ? 2 : 1);
                                setName2(0);
                                setPage(1)
                            }}
                            style={{ width: "10%", minWidth: "110px" }}
                        >
                            <span>획득 다이아</span>
                            <span style={{ paddingTop: "1px" }}>
                                <span className="index_sort-btn__eWsx8">
                                    <svg width="9" height="6" viewBox="0 0 5 3" fill="none">
                                        <path
                                            className={`${name1 === 2 ? "fill-color" : ""}`}
                                            d="M0.342163 3L3.77567 3C3.96395 3 4.11658 2.85941 4.11658 2.68599C4.11658 2.62399 4.09665 2.56339 4.05932 2.5118L2.34257 0.139848C2.23813 -0.00444984 2.02647 -0.0434422 1.86981 0.0527565C1.83236 0.0757532 1.80023 0.105353 1.77526 0.139848L0.0585074 2.5118C-0.0459313 2.6561 -0.00359917 2.85106 0.153059 2.94726C0.20906 2.98165 0.274858 3 0.342163 3Z"
                                            fill={"#999"}
                                        />
                                    </svg>
                                    <svg width="9" height="6" viewBox="0 0 5 3" fill="none">
                                        <path
                                            className={`${name1 === 1 ? "fill-color" : ""}`}
                                            d="M3.77442 0H0.340911C0.152631 0 0 0.140589 0 0.314014C0 0.376008 0.0199222 0.436615 0.0572559 0.488197L1.77401 2.86015C1.87845 3.00445 2.09011 3.04344 2.24677 2.94724C2.28422 2.92425 2.31635 2.89465 2.34132 2.86015L4.05807 0.488197C4.16251 0.343899 4.12018 0.148937 3.96352 0.0527385C3.90752 0.0183503 3.84172 0 3.77442 0Z"
                                            fill={"#999"}
                                        />
                                    </svg>
                                </span>
                            </span>
                        </div>

                        {/* 이후 나머지 테이블 헤더들 */}
                        <div style={{ width: "10%", minWidth: "120px" }}>"코인전환"시<br />지급될 코인</div>
                        <div style={{ width: "5%", minWidth: "80px" }}>코인 전환</div>
                        <div style={{ width: "15%", minWidth: "80px" }}>전송 전<br />코인</div>
                        <div style={{ width: "5%", minWidth: "80px" }}>지갑 전송</div>
                        <div style={{ width: "10%", minWidth: "100px" }}>전송된 코인</div>
                        <div style={{ width: "10%", minWidth: "100px" }}>지갑주소</div>
                        <div style={{ width: "5%", minWidth: "70px" }}>에너지</div>
                        <div style={{ width: "10%", minWidth: "150px" }}>강화 상태</div>
                        <div style={{ width: "5%", minWidth: "50px" }}>스킨</div>
                        <div style={{ width: "20%", minWidth: "180px" }}>기타 설명</div>
                        <div style={{ width: "10%", minWidth: "80px" }}>게임 정보<br />초기화</div>
                    </div>

                    {/* 바디 */}
                    <div className='table-body' style={{ minHeight: "600px" }}>
                        {
                            spinner
                                ? <div className='spinner-modal'>
                                    <SyncLoader color="#003577" />
                                </div>
                                : data.length === 0
                                    ? <div className='data-nofound'>
                                        <img src='/img/img_nofound.png' alt='nofound-light' />
                                        <img src='/img/img_nofound_dark.svg' alt='nofound-dark' style={{ display: "none" }} />
                                        <p>NO RECORDS FOUND</p>
                                    </div>
                                    : <>
                                        {
                                            data.map(function (a, i) {
                                                return (
                                                    <MemberItem
                                                        key={i}
                                                        item={a}
                                                        darkname={darkname}
                                                        dark={dark}
                                                        setClickId={setClickId}
                                                        setSkinModal={setSkinModal}
                                                        setDiaModal={setDiaModal}
                                                        setUpgradeModal={setUpgradeModal}
                                                        setWalletAddressModal={setWalletAddressModal}
                                                        setSecuretCodeModal={setSecuretCodeModal}
                                                        setReload={setReload}
                                                        setMessage={setMessage}
                                                        rateData={rateData}
                                                    />
                                                )
                                            })
                                        }
                                        <NewPage initialData={totalData} page={page} setPage={setPage} maxFirstPage={20} />
                                    </>
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

function MemberItem({ item, darkname, setClickId, setSkinModal, setDiaModal, setUpgradeModal, setWalletAddressModal, setSecuretCodeModal, setReload, setMessage, rateData }) {
    let navigate = useNavigate();
    let dispatch = useDispatch();

    let upgradeStatus = item?.user_upgrade_status ? JSON.parse(item.user_upgrade_status) : []

    const [idSelect, setIdSelect] = useState(false)
    const [descSelect, setDescSelect] = useState(false)

    const [textInput, setTextInput] = useState("")
    const [topStyle, setTopStyle] = useState('30px');
    const [descTopStyle, setDescTopStyle] = useState('30px');

    const idHeightRef = useRef(null)
    const descHeightRef = useRef(null)

    const handleIdSelect = () => {
        setIdSelect(true);

        if (idHeightRef.current) {
            const rect = idHeightRef.current.getBoundingClientRect();
            const windowHalf = window.innerHeight / 2;

            // 화면 절반 기준으로 위치 조정
            const calculatedTop = rect.top > windowHalf ? `${-130}px` : `${30}px`;
            setTopStyle(calculatedTop);
        }
    };
    const handleDescSelect = () => {
        setDescSelect(true);

        if (descHeightRef.current) {
            const rect = descHeightRef.current.getBoundingClientRect();
            const windowHalf = window.innerHeight / 2;

            // 화면 절반 기준으로 위치 조정
            const calculatedTop = rect.top > windowHalf ? `${-115}px` : `${30}px`;
            setDescTopStyle(calculatedTop);
        }
    };


    const onChangeTextInput = (e) => {
        setTextInput(e.target.value)
    }

    const onSubmitReset = async () => {
        if (window.confirm("리셋하시겠습니까?")) {
            await axios.post(process.env.REACT_APP_API + '/api/user/reset', {
                userId: item.id,
            }, {
            }).then((response) => {
                let tmp = response.data
                if (tmp?.code == 1000) {
                    setReload(e => !e)
                }
            }).catch((error) => {
                console.log(error)
            })
        }
    };

    const onSubmitDesc = async () => {
        await axios.post(process.env.REACT_APP_API + '/api/user/update-desc', {
            userId: item.id,
            desc: textInput
        }, {
        }).then((response) => {
            let tmp = response.data
            if (tmp?.code == 1000) {
                setReload(e => !e)
            }
        }).catch((error) => {
            console.log(error)
        })
    };

    const onSubmitLock = async (status) => {
        await axios.post(process.env.REACT_APP_API + '/api/wallet/lock', {
            userId: item.id,
            status: status
        }, {
        }).then((response) => {
            let tmp = response.data
            console.log(tmp)
            if (tmp?.code == 1000) {
                setReload(e => !e)
            }
        }).catch((error) => {
            console.log(error)
        })
    };

    const onSubmitWithdraw = async (id) => {
        if (window.confirm(`${id}의 출금하시겠습니까?`)) {
            await axios.post(process.env.REACT_APP_API + '/api/airdrop/pay', {
                userId: id
            }, {
            }).then((response) => {
                let tmp = response.data
                if (tmp?.code == 1000) {
                    setMessage({ code: 0, msg: tmp?.msg ?? "" })
                    setReload(e => !e)
                }
                else {
                    setMessage({ code: 1, msg: tmp?.msg ?? "" })
                }
            }).catch((error) => {
                console.log(error)
            })
        }
    };

    const onSubmitEndSeason = async () => {
        if (window.confirm("현재를 기준으로 전환 가능 코인 개수가 정해집니다.")) {
            await axios.post(process.env.REACT_APP_API + '/api/season/change', {
                userId: item.id
            }).then((response) => {
                let tmp = response.data
                if (tmp?.code == 1000) {
                    setReload(e => !e)
                }
            }).catch((error) => {
                console.log(error)
            })
        }
    };

    return (
        <>
            <div className={`table-body-tr member ${darkname}`}>
                <div className='onclick right td' style={{ width: "5%", minWidth: "100px" }} ref={idHeightRef} onClick={() => handleIdSelect()}>
                    {item.id}
                    {
                        idSelect
                            ?
                            <>
                                <div className='modal' onClick={(e) => { e.stopPropagation(); setIdSelect(false) }}></div>
                                <div className={`member-id-select-box ${darkname}`} style={{ top: topStyle }}>
                                    <div onClick={() => { dispatch(changeLogId(item.id)); navigate('/logAccess'); }}>접속 로그</div>
                                    <div onClick={() => { dispatch(changeLogId(item.id)); navigate('/logGold'); }}>다이아 로그</div>
                                    <div onClick={() => { dispatch(changeLogId(item.id)); navigate('/logEnergy'); }}>에너지 로그</div>
                                    <div onClick={() => { dispatch(changeLogId(item.id)); navigate('/logJackpot'); }}>잭팟 로그</div>
                                    <div onClick={() => { dispatch(changeLogId(item.id)); navigate('/logAirdrop'); }}>에어드랍 로그</div>
                                </div>
                            </>
                            :
                            ""
                    }
                </div>
                <div className='left td' style={{ width: "15%", minWidth: "120px", }}>
                    <div className="table-overflow-hidden">
                        {item.user_name}
                    </div>
                </div>
                <div
                    className='onclick right td'
                    style={{ width: "10%", minWidth: "130px" }}
                    onClick={() => {
                        setClickId(item);
                        setSecuretCodeModal(true);
                    }}
                >
                    <div className="table-overflow-hidden">
                        {
                            item?.securet_code?.includes("feelspic.com")
                                ? item?.securet_code?.split('u=')[1] // Android는 u= 뒤 8자리
                                : item?.securet_code?.includes("securet.kr")
                                    ? new URLSearchParams(item.securet_code.split('?')[1]).get('nick') // iOS는 nick 파라미터 추출
                                    : ""
                        }
                    </div>
                    {
                        item?.securet_code &&
                        <FontAwesomeIcon icon={faPenToSquare} style={{ marginLeft: "5px", color: 'gray' }} />
                    }
                </div>


                <div className='td' style={{ width: "10%", minWidth: "100px" }}>
                    {
                        moment(item.access_date).isSame(moment(), 'day')
                            ? moment(item.access_date).format('HH:mm:ss') // 오늘이면 시:분:초 형식
                            : moment(item.access_date).format('YY-MM-DD') // 오늘이 아니면 년-월-일 형식
                    }
                </div>
                <div className='onclick right td' style={{ width: "10%", minWidth: "110px" }} onClick={() => { setClickId(item); setDiaModal(true) }}>
                    {changeNum(item.user_gold)}<FontAwesomeIcon icon={faPenToSquare} style={{ marginLeft: "5px", color: 'gray' }} />
                </div>

                <div className='td' style={{ width: "10%", minWidth: "120px" }}>
                    {(() => {
                        const userGold = Number(item.user_gold);
                        const coinRate = Number(rateData.coin);
                        const pointRate = Number(rateData.point);
                        // 계산식: (보유 다이아 * 코인비율) / 다이아비율
                        const result = (userGold * coinRate) / pointRate;
                        // coinRate와 동일한 소수점 자릿수 사용
                        const decimals = String(coinRate).split('.')[1]?.length || 0;
                        // toFixed로 소수점 자릿수 맞추기 (반올림하지 않고 잘라내기)
                        const resultStr = String(result);
                        const [whole, decimal] = resultStr.split('.');
                        const finalDecimal = decimal ? decimal.slice(0, decimals) : '0'.repeat(decimals);
                        return `${changeNum(whole)}${decimals > 0 ? '.' + finalDecimal : ''}`;
                    })()}
                </div>
                <div className='td' style={{ width: "5%", minWidth: "80px" }}>
                    <div className="upgrade-btn" onClick={() => onSubmitEndSeason()}>전환</div>
                </div>
                <div className='td' style={{ width: "15%", minWidth: "80px" }}>
                    {Number(item?.walletCoin) <= 1e-10 ? '-' : Number(item?.walletCoin)}
                </div>
                <div className='td' style={{ width: "5%", minWidth: "80px" }}>
                    {
                        Number(item?.walletCoin) > 0
                            ?
                            <div className="upgrade-btn" onClick={() => onSubmitWithdraw(item?.id ?? "")}>전송</div>
                            :
                            ""
                    }
                </div>
                <div className='td' style={{ width: "10%", minWidth: "100px" }}>
                    {Number(item?.totalAirdropCoin)}
                </div>
                <div className='td' style={{ width: "10%", minWidth: "100px", display: "flex", gap: "5px", justifyContent: "flex-start", cursor: item?.walletAddress ? "pointer" : "" }}>
                    <div style={{ color: "gray" }}>{item?.walletUnlockStatus ? item?.walletUnlockStatus == "N" ? <FontAwesomeIcon icon={faLock} style={{ fontSize: "14px" }} onClick={() => onSubmitLock("Y")} /> :
                        <FontAwesomeIcon icon={faLockOpen} style={{ fontSize: "14px" }} onClick={() => onSubmitLock("N")} />
                        : ""}</div>
                    <div className="table-overflow-hidden"
                        onClick={() => {
                            if (item?.walletAddress) {
                                setClickId(item);
                                setWalletAddressModal(true);
                            }
                        }}>{item?.walletAddress ?? ""}</div>
                    <div style={{ color: "gray" }}
                        onClick={() => {
                            if (item?.walletAddress) {
                                setClickId(item);
                                setWalletAddressModal(true);
                            }
                        }}>{item?.walletAddress ? <FontAwesomeIcon icon={faPenToSquare} style={{ color: 'gray' }} /> : ""}</div>
                </div>

                <div className='right td' style={{ width: "5%", minWidth: "70px" }}>{changeNum(item.user_last_energy)}</div>
                <div className='onclick td' style={{ width: "10%", minWidth: "150px" }} onClick={() => { setClickId(item); setUpgradeModal(true) }}>
                    탭 : {upgradeStatus["tab-plus"]} / 에너지 : {upgradeStatus["energy-limit"]} <FontAwesomeIcon icon={faPenToSquare} style={{ marginLeft: "5px", color: 'gray' }} />
                </div>

                <div className='onclick td' style={{ width: "5%", minWidth: "50px" }} onClick={() => { setClickId(item); setSkinModal(true) }}>
                    {item.user_current_skin}
                </div>
                <div className='onclick td space-between' style={{ width: "20%", minWidth: "180px" }} ref={descHeightRef} onClick={() => handleDescSelect()}>
                    <div>{item.user_desc}</div>
                    <div><FontAwesomeIcon icon={faPenToSquare} style={{ marginLeft: "5px", color: 'gray' }} /></div>
                    {
                        descSelect
                            ?
                            <>
                                <div className='modal' onClick={(e) => { e.stopPropagation(); setDescSelect(false) }}></div>
                                <div className={`memeber-desc ${darkname}`} style={{ top: descTopStyle }}>
                                    <textarea
                                        style={{
                                            resize: 'none',
                                            whiteSpace: 'pre-wrap',
                                            wordWrap: 'break-word',
                                            overflow: 'auto',
                                            height: '70px',
                                            outline: 'none',
                                            width: '100%',
                                            border: 'none'
                                        }}
                                        value={textInput} onChange={onChangeTextInput} placeholder={item.user_desc}
                                    />
                                    <div className='member-desc-btn'>
                                        <div className='member-desc-btn-1' onClick={() => onSubmitDesc()}>수정</div>
                                        <div className='member-desc-btn-2' onClick={(e) => { e.stopPropagation(); setDescSelect(false) }}>취소</div>
                                    </div>
                                </div>
                            </>
                            :
                            ""
                    }
                </div>
                <div className='onclick td' style={{ width: "10%", minWidth: "80px" }} onClick={() => onSubmitReset()}>
                    <ListRestart style={{ color: "gray" }} />
                </div>
            </div >
        </>
    )
}

function MemberModal({ darkname, setSkinModal, clickId, setReload }) {
    const [spinner, setSpinner] = useState(true)
    const [page, setPage] = useState(1)
    const [skinList, setSkinList] = useState([])

    useEffect(() => {
        SkinData()
    }, [])

    const SkinData = async () => {
        await axios.get(process.env.REACT_APP_API + '/api/user/owned', {
            params: {
                userId: clickId.id
            },
            // headers: { Authorization: `Bearer ${JWT}` }
        }).then((response) => {
            let tmp = response.data
            if (tmp?.code == 1000) {
                setSkinList(tmp?.data?.owned ?? [])
                setSpinner(false)
            }
        }).catch((error) => {
            console.log(error)
        })
    };

    return (
        <div className='modal'>
            <div className='modal-box'>
                <div className='modal-1' style={{ width: "800px" }}>
                    <div className='modal-1-header'>보유스킨 확인</div>
                    <div className={`member-2 ${darkname}`}>
                        {/* <div className={`table-head ${darkname}`}>
                            <div>미리보기</div>
                            <div>이름</div>
                        </div> */}
                        <div className='table-grid' style={{ minHeight: "500px", height: "500px", overflow: "scroll" }}>
                            {
                                spinner
                                    ?
                                    <div className='spinner-modal'>
                                        <SyncLoader color="#003577" />
                                    </div>
                                    :
                                    skinList.length === 0
                                        ?
                                        <div className='data-nofound'>
                                            <img src='/img/img_nofound.png'></img>
                                            <img src='/img/img_nofound_dark.svg' style={{ display: "none" }}></img>
                                            <p>NO RECORDS FOUND</p>
                                        </div>
                                        :
                                        <>
                                            {
                                                skinList.map(function (a, i) {
                                                    return (
                                                        <SkinItem key={i} num={i + 1} item={a} darkname={darkname} clickId={clickId} setReload={setReload} setSkinModal={setSkinModal} />
                                                    )
                                                })
                                            }
                                        </>

                            }
                        </div>
                    </div>

                    <div className='modal-btn-box'>
                        <div className={`modal-btn ${darkname}`} onClick={() => setSkinModal(false)}>취소</div>
                    </div>
                </div>
            </div>
        </div>
    )
}

function SkinItem({ num, item, darkname, clickId, setReload, setSkinModal }) {
    const onSubmitSkinDelete = async () => {
        await axios.post(process.env.REACT_APP_API + '/api/user/owned-remove', {
            userId: clickId.id,
            skinId: item.id
        }, {
        }).then((response) => {
            let tmp = response.data
            if (tmp?.code == 1000) {
                setReload(e => !e)
                setSkinModal(false)
            }
        }).catch((error) => {
            console.log(error)
        })
    };

    return (
        <div className='skin-card'>
            <div className='skin-card-header'>
                <div className='skin-card-header-1'>{num}</div>
                <div className='skin-card-header-2'>{item.skin_name}</div>
            </div>
            <img src={item.skin_img} style={{ height: '125px', margin: "10px 0" }}></img>
            {
                item.skin_name == "cat"
                    ?
                    <div className='skin-card-btn'>기본</div>
                    :
                    <div className='skin-card-btn delete' onClick={() => onSubmitSkinDelete()}>삭제</div>
            }
        </div>
    )
}

function DiaModal({ darkname, setDiaModal, clickId, setReload }) {
    const [input, setInput] = useState("")
    const [isIncrease, setIsIncrease] = useState(true);

    const onChangeInput = (e) => {
        const { value } = e.target
        const onlyNumber = value.replace(/[^0-9]/g, "")
        setInput(onlyNumber)
    }

    const onSubmitUpdateGold = async () => {
        await axios.post(process.env.REACT_APP_API + '/api/user/give-gold', {
            userId: clickId.id,
            gold: input,
            isIncrease: isIncrease
        }, {
        }).then((response) => {
            let tmp = response.data
            if (tmp?.code == 1000) {
                setDiaModal(false)
                setReload(e => !e)
            }
        }).catch((error) => {
            console.log(error)
        })
    };

    return (
        <div className='modal'>
            <div className='modal-box'>
                <div className='modal-1' style={{ width: "400px" }}>
                    <div className='modal-1-header'>보유 다이아 수정</div>

                    <div style={{ marginBottom: "30px" }}>
                        <div style={{ width: "100%", textAlign: "left" }}>
                            <div className='password'>보유 다이아</div>
                            <div className={`password-1 ${darkname}`}>
                                <div>{clickId.user_gold}</div>
                            </div>
                        </div>
                        <div style={{ width: "100%", textAlign: "left" }}>
                            <div className='password'>추가할 다이아 수량</div>
                            <div style={{ width: "100%", textAlign: "left", marginBottom: "5px", fontSize: "12px", display: "flex", alignItems: "center" }}>
                                <div style={{ marginRight: "12px", display: "flex", alignItems: "center", gap: "2px", cursor: "pointer" }}
                                    onClick={() => setIsIncrease(true)}>
                                    <input
                                        type="radio"
                                        name="isIncrease"
                                        value={true}
                                        checked={isIncrease}
                                        style={{ marginTop: "3px" }}
                                    />{" "}
                                    증가
                                </div>
                                <div style={{ marginRight: "12px", display: "flex", alignItems: "center", gap: "2px", cursor: "pointer" }}
                                    onClick={() => setIsIncrease(false)}>
                                    <input
                                        type="radio"
                                        name="isIncrease"
                                        value={false}
                                        checked={!isIncrease}
                                        style={{ marginTop: "3px" }}
                                    />{" "}
                                    감소
                                </div>
                            </div>
                            <div className={`password-1 ${darkname}`}>
                                <input value={input} onChange={onChangeInput} placeholder='추가할 다이아 수량' />
                            </div>
                        </div>
                    </div>
                    <div className='modal-btn-box'>
                        <div className={`modal-btn ${darkname}`} onClick={() => { onSubmitUpdateGold() }}>확인</div>
                        <div className={`modal-btn ${darkname}`} onClick={() => setDiaModal(false)}>취소</div>
                    </div>
                </div>
            </div>
        </div>
    )
}

function UpgradeModal({ darkname, setUpgradeModal, clickId, setReload, upgradeLevel }) {
    let upgradeStatus = JSON.parse(clickId.user_upgrade_status)

    const [inputTap, setInputTap] = useState("")
    const [inputEnergy, setInputEnergy] = useState("")

    const onChangeInputTap = (e) => {
        const { value } = e.target
        const onlyNumber = value.replace(/[^0-9]/g, "")
        setInputTap(onlyNumber)
    }
    const onChangeInputEnergy = (e) => {
        const { value } = e.target
        const onlyNumber = value.replace(/[^0-9]/g, "")
        setInputEnergy(onlyNumber)
    }

    const onSubmitUpdateLevel = async () => {
        await axios.post(process.env.REACT_APP_API + '/api/user/update-upgrade', {
            userId: clickId.id,
            status: JSON.stringify({ "tab-plus": Number(inputTap), "energy-limit": Number(inputEnergy) })
        }, {
        }).then((response) => {
            let tmp = response.data
            if (tmp?.code == 1000) {
                setUpgradeModal(false)
                setReload(e => !e)
            }
        }).catch((error) => {
            console.log(error)
        })
    };

    return (
        <div className='modal'>
            <div className='modal-box'>
                <div className='modal-1' style={{ width: "400px" }}>
                    <div className='modal-1-header'>강화 수치 수정</div>

                    <div style={{ marginBottom: "30px" }}>
                        <div style={{ width: "100%", textAlign: "left" }}>
                            <div className='password'>탭 최대 레벨: {upgradeLevel[0]}</div>
                            <div className={`password-1 ${darkname}`}>
                                <input value={inputTap} onChange={onChangeInputTap} placeholder={`탭 기존 레벨: ${upgradeStatus['tab-plus']}`} />
                            </div>
                        </div>
                        <div style={{ width: "100%", textAlign: "left" }}>
                            <div className='password'>에너지 최대 레벨: {upgradeLevel[1]}</div>
                            <div className={`password-1 ${darkname}`}>
                                <input value={inputEnergy} onChange={onChangeInputEnergy} placeholder={`에너지 기존 레벨: ${upgradeStatus['energy-limit']}`} />
                            </div>
                        </div>
                    </div>
                    <div className='modal-btn-box'>
                        <div className={`modal-btn ${darkname}`} onClick={() => { onSubmitUpdateLevel() }}>확인</div>
                        <div className={`modal-btn ${darkname}`} onClick={() => setUpgradeModal(false)}>취소</div>
                    </div>
                </div>
            </div>
        </div>
    )
}

function WalletAddressModal({ darkname, setWalletAddressModal, clickId, setReload }) {
    const [input, setInput] = useState("")
    const onChangeInput = (e) => {
        const { value } = e.target;
        const filteredValue = value.replace(/[^a-zA-Z0-9]/g, ""); // 숫자와 알파벳만 허용
        setInput(filteredValue);
    };

    const onSubmitUpdateAddress = async () => {
        await axios.post(process.env.REACT_APP_API + '/api/wallet/update', {
            id: clickId.id,
            address: input
        }, {
        }).then((response) => {
            let tmp = response.data
            if (tmp?.code == 1000) {
                setWalletAddressModal(false)
                setReload(e => !e)
            }
        }).catch((error) => {
            console.log(error)
        })
    };

    return (
        <div className='modal'>
            <div className='modal-box'>
                <div className='modal-1' style={{ width: "400px" }}>
                    <div className='modal-1-header'>지갑 주소 수정</div>

                    <div style={{ marginBottom: "30px" }}>
                        <div style={{ width: "100%", textAlign: "left" }}>
                            <div className='password'>지갑 주소</div>
                            <div className={`password-1 ${darkname}`} style={{ overflowX: "auto", whiteSpace: "nowrap" }}>
                                <div>{clickId.walletAddress}</div>
                            </div>
                        </div>
                        <div style={{ width: "100%", textAlign: "left" }}>
                            <div className='password'>수정할 지갑 주소</div>
                            <div className={`password-1 ${darkname}`}>
                                <input value={input} onChange={onChangeInput} placeholder='수정할 지갑 주소' />
                            </div>
                        </div>
                    </div>
                    <div className='modal-btn-box'>
                        <div className={`modal-btn ${darkname}`} onClick={() => { onSubmitUpdateAddress() }}>확인</div>
                        <div className={`modal-btn ${darkname}`} onClick={() => setWalletAddressModal(false)}>취소</div>
                    </div>
                </div>
            </div>
        </div>
    )
}

function SecuretCodeModal({ darkname, setSecuretCodeModal, clickId, setReload }) {
    const [input, setInput] = useState(clickId?.securet_code ?? "")
    const onChangeInput = (e) => {
        const { onlyNumber } = e.target.value
        setInput(onlyNumber)
    }

    const onSubmitDelete = async () => {
        await axios.post(process.env.REACT_APP_API + '/api/user/securet-code/delete', {
            userId: clickId.id
        }, {
        }).then((response) => {
            let tmp = response.data
            if (tmp?.code == 1000) {
                setSecuretCodeModal(false)
                setReload(e => !e)
            }
        }).catch((error) => {
            console.log(error)
        })
    };

    return (
        <div className='modal'>
            <div className='modal-box'>
                <div className='modal-1' style={{ width: "400px" }}>
                    <div className='modal-1-header'>시큐릿 코드 수정</div>

                    <div style={{ marginBottom: "30px" }}>
                        <div style={{ width: "100%", textAlign: "left" }}>
                            <div className='password'>텔레그램 아이디</div>
                            <div className={`password-1 ${darkname}`}>
                                <div>{clickId.id}</div>
                            </div>
                        </div>
                        <div style={{ width: "100%", textAlign: "left" }}>
                            <div className='password'>시큐릿 코드</div>
                            <div className={`password-1 ${darkname}`}>
                                <input value={input} disabled />
                                {/* <input value={input} onChange={onChangeInput} placeholder='시큐릿 코드' /> */}
                            </div>
                        </div>
                    </div>
                    <div className='modal-btn-box'>
                        <div className={`modal-btn ${darkname}`} onClick={() => { onSubmitDelete() }}>삭제</div>
                        <div className={`modal-btn ${darkname}`} onClick={() => setSecuretCodeModal(false)}>취소</div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Member;